export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Gestoría Moreno Martín Alhambra",
  alternateName: [
    "Gestoría Moreno",
    "Gestoría Moreno Granada",
    "Gestorías Moreno Martín Alhambra S.L.P.",
  ],
  description:
    "Gestoría en Granada especializada en asesoría fiscal, laboral, contable y gestión administrativa. Más de 60 años de experiencia profesional desde 1961.",
  url: "https://gestoriamoreno.com",
  logo: "https://gestoriamoreno.com/logo.png",
  image: "https://gestoriamoreno.com/office-picture.jpg",
  telephone: "+34 958 805 110",
  email: "info@gestoriamoreno.com",
  foundingDate: "1961",
  founder: {
    "@type": "Person",
    name: "José Moreno Martín",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Avenida Divina Pastora, 9, local 13",
    addressLocality: "Granada",
    addressRegion: "Andalucía",
    postalCode: "18012",
    addressCountry: "ES",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 37.1773,
    longitude: -3.5986,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "08:30",
      closes: "14:30",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
      opens: "17:00",
      closes: "19:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Friday",
      opens: "08:00",
      closes: "15:00",
    },
  ],
  serviceArea: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: 37.1773,
      longitude: -3.5986,
    },
    geoRadius: "50000",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Servicios de Gestoría",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Asesoría Fiscal",
          description: "Gestión de impuestos, declaraciones fiscales y optimización tributaria",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Asesoría Laboral",
          description: "Gestión de nóminas, contratos laborales y Seguridad Social",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Asesoría Contable",
          description: "Contabilidad empresarial, estados financieros y análisis económico",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Gestión Administrativa",
          description: "Tramitación de licencias, permisos y gestiones administrativas",
        },
      },
    ],
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.6",
    reviewCount: "73",
    bestRating: "5",
    worstRating: "1",
  },
  areaServed: [
    {
      "@type": "City",
      name: "Granada",
    },
    {
      "@type": "State",
      name: "Andalucía",
    },
  ],
  priceRange: "€€",
  currenciesAccepted: "EUR",
  paymentAccepted: "Cash, Credit Card, Bank Transfer",
  sameAs: ["https://www.linkedin.com/company/gestoriamoreno"],
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Gestoría Moreno Martín Alhambra",
  url: "https://gestoriamoreno.com",
  logo: {
    "@type": "ImageObject",
    url: "https://gestoriamoreno.com/logo.png",
    width: 300,
    height: 100,
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+34 958 805 110",
    contactType: "customer service",
    email: "info@gestoriamoreno.com",
    availableLanguage: "Spanish",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Avenida Divina Pastora, 9, local 13",
    addressLocality: "Granada",
    addressRegion: "Andalucía",
    postalCode: "18012",
    addressCountry: "ES",
  },
};

export const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Inicio",
      item: "https://gestoriamoreno.com/",
    },
  ],
};
